<template>
    <div class="boolean">
        <div class="boolean-icon-wrapper">
            <div class="boolean-icon success-icon" v-if="row[field]">
                <i class="far fa-check"></i>
            </div>
            <div class="boolean-icon failed-icon" v-if="!row[field]">
                <i class="far fa-times"></i>
            </div>
        </div>
    </div>
</template>

<script lang="ts">
export default {
    props: ['row', 'field', 'exported'],
    // eslint-disable-next-line
    setup(props: any) {
        return {
            props,
        };
    },
};
</script>

<style scoped>
.boolean {
    --light-green: var(--primary-600);
    --light-red: var(--red-100);
    display: flex;
    justify-content: center;
    align-items: center;
}

.boolean-icon-wrapper {
    --icon-size: 25px;
    object-fit: scale-down;
}

.boolean-icon {
    display: flex;
    justify-content: center;
    align-items: center;
    width: var(--icon-size);
    height: var(--icon-size);
    min-width: var(--icon-size);
    min-height: var(--icon-size);
    max-width: var(--icon-size);
    max-height: var(--icon-size);
    border-radius: 50%;
}

.success-icon {
    background: var(--light-green);
    color: #fff;
    font-size: 1.2rem;
}

.failed-icon {
    background: var(--light-red);
    color: #fff;
    font-size: 1.2rem;
}
</style>
